import React from 'react';
import { Button, Icon } from 'antd';

const PopoverManual = ({ onConfirm, onCancel, loading, title }) => (
  <div className="ant-popover-content">
    <div className="ant-popover-inner">
      <div className="ant-popover-inner-content">
        <div className="ant-popover-message">
          <Icon type="exclamation-circle" style={{ color: 'orange' }} />
          <div className="ant-popover-message-title">{title}</div>
        </div>
        <div className="ant-popover-buttons">
          <Button size="small" onClick={onCancel}>
            No
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            size="small"
            loading={loading}
            type="primary"
            onClick={onConfirm}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  </div>
);

PopoverManual.defaultProps = {};

PopoverManual.propTypes = {};

export default PopoverManual;
